import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { tap } from 'rxjs';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private readonly _auth: AuthService,
    private readonly _logger: LoggerService,
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    private readonly _destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this._auth.isAuthenticated$
      .pipe(
        tap((isAuthenticated: boolean) => {
          const organization = this._route?.snapshot?.queryParamMap?.get('organization') ?? null;
          const invitation = this._route?.snapshot?.queryParamMap?.get('invitation') ?? null;

          if (organization) {
            if (invitation) {
              this._logger.info(`A user from zenity account id ${organization} is trying to accept invitation`);
              this._auth.loginWithRedirect({
                authorizationParams: {
                  organization: organization,
                  invitation: invitation,
                  prompt: 'login',
                },
              });
            } else {
              if (!isAuthenticated) {
                this._auth.loginWithRedirect();
              } else {
                this._router.navigateByUrl('/app');
              }
            }
          }
        }),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }
}
